/**
 * @desc 根据包裹单号获取订单包裹列表Item
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.listByOpNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/systemOrderPackage/listByOpNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
